import React, { FormEvent, useCallback, useState } from 'react';
import './contactForm.css';

type Props = {
  submitCallback: Function,
  availableTimes?: string[] // Assuming times are strings for simplicity
}

function ContactForm({ submitCallback, availableTimes }: Props) {
  // State for form fields
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [bookingTime, setBookingTime] = useState(availableTimes && availableTimes[0] || undefined); // Default to first available time or empty string
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');

  const [hasSubmitted, setHasSubmitted] = useState(false);

  // Regex pattern for phone and email validation
  const phoneRegex = /^\+?[1-9]\d{1,14}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Validate phone number
  const validatePhone = (phone: string) => {
    if (!phoneRegex.test(phone)) {
      setPhoneError('请输入正确的电话号码');
    } else {
      setPhoneError('');
    }
  };

  // Validate email if not empty
  const validateEmail = (email: string) => {
    if (email && !emailRegex.test(email)) {
      setEmailError('email格式错误');
    } else {
      setEmailError('');
    }
  };

  // Handle phone and email changes
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPhone = e.target.value;
    setPhone(newPhone);
    validatePhone(newPhone);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    validateEmail(newEmail);
  };

  // Handle booking time change
  const handleBookingTimeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setBookingTime(e.target.value);
  };

  // Handle form submission
  const handleSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault(); // Prevent default form submission behavior
      if (!phoneError && !emailError) {
        submitCallback({ name, phone, email, bookingTime });
        console.log('Form submitted with:', { name, phone, email, bookingTime });
        setHasSubmitted(true);
      }
    },
    [name, phone, email, bookingTime, submitCallback, setHasSubmitted]
  );

  return (
    <form className="contact-form" onSubmit={handleSubmit}
          style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '300px', margin: 'auto' }}>
      <label>
        姓名(选填):
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
      </label>
      <label>
        电话(必填):
        <input type="tel" required value={phone} onChange={handlePhoneChange} />
        {phoneError && <div className="contact-form-error">{phoneError}</div>}
      </label>
      <label>
        邮箱(选填):
        <input type="email" value={email} onChange={handleEmailChange} />
        {emailError && <div className="contact-form-error">{emailError}</div>}
      </label>
      {
        availableTimes &&
        <label>
          Booking Time:
          <select value={bookingTime} onChange={handleBookingTimeChange}>
            {availableTimes.map((time, index) => (
              <option key={index} value={time}>{time}</option>
            ))}
          </select>
        </label>
      }
      <button type="submit" disabled={!!(!phone || emailError || phoneError || hasSubmitted)}>Submit</button>
    </form>
  );
}

export default ContactForm;
